import { Axios } from 'axios'

import { GsResponse, RawResponse, toGsResponse } from '../../goodstack'
import { VolunteeringTimeLogType } from '../../opportunity/dto'

import { MutationFn } from '@percent/workplace-giving/common/hooks/useMutation/useMutation.types'
import { EditVolunteeringActivityParams } from './editVolunteeringActivity.types'

export const editVolunteeringActivity: MutationFn<[EditVolunteeringActivityParams], GsResponse<any>> = async (
  client: Axios,
  [params]
) => {
  const { timeLogId, duringWorkingHours, confirmed, ...activityLogParams } = params
  const { platform, timeLogs, ...rest } = activityLogParams

  const dateTime = {
    startTime: timeLogs[0].startTime,
    endTime: timeLogs[0].endTime
  }

  const confirmedField = confirmed !== undefined ? { confirmed } : {}

  const requestData =
    platform === VolunteeringTimeLogType.OffPlatform
      ? {
          ...rest,
          ...dateTime,
          ...(duringWorkingHours !== undefined ? { duringWorkingHours } : {}),
          ...confirmedField,
          ...(platform === VolunteeringTimeLogType.OffPlatform &&
            activityLogParams.activities && {
              activities: JSON.stringify(activityLogParams.activities)
            }),
          ...(platform === VolunteeringTimeLogType.OffPlatform &&
            activityLogParams.skills && {
              skills: JSON.stringify(activityLogParams.skills)
            })
        }
      : {
          ...dateTime,
          ...(duringWorkingHours !== undefined ? { duringWorkingHours } : {}),
          ...confirmedField,
          ...rest
        }

  const response = await client.patch<RawResponse<any>>(`v1/account/volunteering-time-logs/${timeLogId}`, requestData, {
    withCredentials: true,
    validateStatus: (_: number) => true
  })

  return toGsResponse(response.status, response.data)
}
